import webSee from '@yaww-websee/core';
import { isAiXueApp, getValueFromUserAgent, isIOS } from '@/utils/ua';

const APPLY_ID = isAiXueApp() ? 'ai-english-ua' : 'xiabao';
const CLIENT_TYPE = isAiXueApp() ? isIOS() ? 40 : 30 : 20;

//  获取当前环境变量中的REPORT_URL
const REPORT_URL = (import.meta as any).env.VITE_REPORT_URL;

const initUserId = () => {
  if (isAiXueApp()) {
    return getValueFromUserAgent('uid');
  }
  return '';
}

export function initAnalytics() {
  if (isAiXueApp()) {
    localStorage.setItem('__web_see_saved_device_id', getValueFromUserAgent('deviceId') as string);
  }
  webSee.init({
    dsn: REPORT_URL,
    apply_id: APPLY_ID,
    repeatCodeError: true,
    silentWhiteScreen: false, // 开启白屏检测
    client_type: CLIENT_TYPE,
    userId: initUserId()
  });
}

export enum EVENTTYPES {
  // 页面展示
  PAGE_SHOW = 10,
  // 模块展示
  MODULE_SHOW = 20,
  // 模块点击 
  MODULE_CLICK = 21,
  // 输入
  INPUT = 22,
  // 视频上传
  VIDEO_SERIRE = 30,
  // 系统上报
  SYSTEM_SERIRE = 100,
}

interface ReportParams {
  event_type: EVENTTYPES;
  event_id: string;
  data?: any
}
export function report(params: ReportParams) {
  webSee.log(params);
}

